'use client'

import { Button, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

import { HOW_IT_WORKS_ASSETS_PREFIX } from '../constants'

type Props = {
  startSellingUrl: string
  startShoppingUrl: string
}

const HowItWorksActions = ({ startSellingUrl, startShoppingUrl }: Props) => {
  const translate = useTranslate('how_it_works')
  const asset = useAsset(HOW_IT_WORKS_ASSETS_PREFIX)

  return (
    <>
      <div className="tear tear--bottom u-background-greyscale-level-6 u-zindex-bump" />
      <div
        className="how-it-works__get-started"
        style={{
          backgroundImage: `url('${asset('get-started-background.svg')}')`,
        }}
      >
        <div className="container">
          <div className="u-clearfix">
            <div className="content-block__content u-text-center">
              <div className="u-ui-padding-vertical-x6-large@desktops u-ui-padding-vertical-x5-large@portables">
                <Text as="span" theme="inverse">
                  <div className="how-it-works__get-started-title">
                    {translate('get_started.title')}
                  </div>
                </Text>
                <Spacer size={Spacer.Size.X2Large} />
                <div className="u-desktops-only">
                  <Button
                    text={translate('start_shopping')}
                    url={startShoppingUrl}
                    inverse
                    inline
                  />
                  <Spacer size={Spacer.Size.Large} orientation={Spacer.Orientation.Vertical} />
                  <Button
                    text={translate('start_selling')}
                    url={startSellingUrl}
                    styling={Button.Styling.Filled}
                    inverse
                    inline
                  />
                </div>
                <div className="u-mobiles-only u-ui-padding-horizontal-large">
                  <Button
                    text={translate('start_selling')}
                    url={startSellingUrl}
                    styling={Button.Styling.Filled}
                    inverse
                  />
                  <Spacer size={Spacer.Size.Large} />
                  <Button text={translate('start_shopping')} url={startShoppingUrl} inverse />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HowItWorksActions
